<template>
  <gh-table-page v-model="selected" ref="table" :show-tabs="true" :args-query="argsQuery" :before-save="beforeSave"
    :tabs="tabs" module="mes.business.mdl.structure.service" cls="StructureService" @start-query="$refs.tree.query()">
    <template #area_left>
      <structure-navigation ref="tree" :attached-all="true" v-model="parent"></structure-navigation>
    </template>
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
        </v-flex>
      </v-layout>
    </template>

    <template #model-prop-Level="{prop,model}">
      <gh-menu :allow-submit="selectedLevel" @submit="updateModelLevel(model)">
        <template #activator="{on}">
          <v-text-field readonly v-model="model.Level" label="层级" id="id" v-on="on"></v-text-field>
        </template>
        <level-navigation v-model="selectedLevel"></level-navigation>
      </gh-menu>

    </template>
    <template #area_detail="{current}">
      <v-card>
        <v-card-title>
          <div class="display-1">企业设备层级模型</div>
        </v-card-title>
        <v-layout row wrap>
          <gh-img id="5cb03d47d2a0eb365cb0e188" :max-height="600" :max-width="600"></gh-img>
        </v-layout>
      </v-card>
    </template>

  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Structure from "./structure.ts";
  export default Structure;
</script>